import React, { useEffect, useState } from "react";
import { Box, IconButton, Modal, TextField, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
// import { mockDataTeam } from "../../../../data/mockData";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import { ToastContainer, toast } from "react-toastify";
import {
  fetchAllOrgData,
  fetchClientNameData,
  fetchOrgClientWiseData,
  insertOrganizationData,
} from "../../../../services/apiService";
import Topbar from "../../../../scenes/global/Topbar";

// import "./style.css";

const GyanniOrg = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [loading, setLoading] = useState(false);
  const [organization, setOrg] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedOrgVal, setSelectedOrgVal] = useState("");
  const [selectedParentVal, setSelectedParentVal] = useState("");
  const [orgCode, setOrgCode] = useState("");
  const [orgName, setOrgName] = useState("");

  const [organizationData, setOrganizationData] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [filterModel, setFilterModel] = useState({
    items: [],
  });

  useEffect(() => {
    let fetchData = async () => {
      setLoading(true);
      try {
        const initialData = await fetchAllOrgData({});

        const limit = initialData.details.total;
        const dataWithLimit = { limit: limit };
        const filteredData = await fetchAllOrgData(dataWithLimit);

        let formattedData = filteredData.details.values.map(
          (organization, index) => ({
            id: organization.id,
            clientName: organization.clientname,
            organizationname: organization.organizationname,
            organizationcode: organization.organizationcode,
            parentname: organization.parentname,
            mstorgnhierarchytypename: organization.mstorgnhierarchytypename,
          })
        );
        setOrg(formattedData);
      } catch (err) {
        console.error("Error fetching clients data:", error);
        setError("Failed to fetch clients data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleClientSelect = (e) => {
    const clientId = e.target.value;
    setSelectedClient(clientId);
    if (clientId) fetchClientNames(clientId);
  };

  const fetchClientNames = async () => {
    const loadingToastId = toast.loading("Loading client data...");

    try {
      const response = await fetchClientNameData({});
      if (response.success) {
        setClients(response.details || []);
        toast.update(loadingToastId, {
          render: "Client data loaded successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
      } else {
        toast.update(loadingToastId, {
          render: "Error: Invalid response structure",
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
      }
    } catch (err) {
      console.error("Error fetching client name data:", err);
      toast.update(loadingToastId, {
        render: "Error fetching client name data.",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };


  const orgTypeMap = {
    BaseClient: 1,
    Client: 2,
    Customer: 3,
    Branch: 4,
    Partner: 5,
  };

  
  const handleOrgClientWise = async () => {
    const loadingToastId = toast.loading("Loading client data...", {
      toastId: "loadingClients",
      containerId: "clientContainer",
    });
  
    try {
      if (!selectedClient) {
        toast.update(loadingToastId, {
          render: "Please select a client first.",
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
        return;
      }
  
      const clientId =
        typeof selectedClient === "string"
          ? parseInt(selectedClient, 10)
          : selectedClient;
  
      const response = await fetchOrgClientWiseData({
        clientId: clientId,
      });
  
      if (response.success) {
        setOrganizationData(response.details || []);
        toast.update(loadingToastId, {
          render: "Organization data loaded successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
      } else {
        toast.update(loadingToastId, {
          render: "Error: Invalid response structure",
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
      }
    } catch (err) {
      console.error("Error fetching client data", err);
      toast.update(loadingToastId, {
        render: "Error: Unable to load data",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };
  

  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
  };

  const openModal = () => {
    setIsModalOpen(true);
    fetchClientNames();
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEdit = () => {
    console.log("Editing client:", currentRow);
    setIsEditModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsEditModalOpen(false);
  };

  const handleDelete = () => {
    console.log("Deleting client:", currentRow);
  };

  const columns = [
    // { field: "id", headerName: "ID" },
    {
      field: "clientName",
      headerName: "Client Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "organizationname",
      headerName: "Organization Name",
      type: "text",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "organizationcode",
      headerName: "Organization Code",
      flex: 1,
    },
    {
      field: "parentname",
      headerName: "Parent Name",
      flex: 1,
    },
    {
      field: "mstorgnhierarchytypename",
      headerName: "MST Orgn Type",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      renderCell: ({ row }) => (
        <div style={{ display: "flex" }}>
          <IconButton
            onClick={() => handleEdit(row)}
            style={{ color: "#6870fa", fontSize: "12px" }}
          >
            <BorderColorIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(row.original)}
            style={{ color: "red", fontSize: "12px" }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  const handleInsertData = async (e) => {
    
    const requestedData = {
      clientid: Number(selectedClient),
      mstorgnhierarchytypeid: orgTypeMap[selectedOrgVal] || null,
      organizationcode: orgCode,
      organizationname: orgName,
      parentid: Number(selectedParentVal),
    };
  
    const loadingToastId = toast.loading("Inserting organization data...", {
      toastId: "loadingInsert",
      containerId: "insertContainer",
    });
  
    try {
      const response = await insertOrganizationData(requestedData);
      // Check the response for success
      if (response.success) {
        toast.update(loadingToastId, {
          render: "Organization Mapped Successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
          containerId: "insertContainer",
        });
      } else {
        // Handle error case based on the response structure
        toast.update(loadingToastId, {
          render: response?.message || "Failed to Map Organization!",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          containerId: "insertContainer",
        });
      }
    } catch (err) {
      console.error("Error inserting organization data", err);
      toast.update(loadingToastId, {
        render: "Error: Unable to insert organization data",
        type: "error",
        isLoading: false,
        autoClose: 2000,
        containerId: "insertContainer",
      });
    }
  };
  
  

  return (
    <>
    <div className="mt-4">
    <Topbar />
    </div>

    <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
      
      <div className="p-4 flex items-center justify-between">
        <h2 className="font-semibold text-xl">Organization Details</h2>
        <div
          style={{ backgroundColor: colors.blueAccent[500] }}
          className="text-white px-4 py-2 rounded-sm"
        >
          <button onClick={openModal} className="font-medium">
            {" "}
            <AddIcon /> Add
          </button>
        </div>
      </div>

      <Box
        m="0 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          checkboxSelection
          rows={organization}
          columns={columns}
          pageSize={pageSize}
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          pagination
          loading={loading}
          filterModel={filterModel}
          onFilterModelChange={handleFilterChange}
        />
      </Box>

      {/* // add org modal pop up  */}
      <div
        className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
          isModalOpen ? "block" : "hidden"
        }`}
      >
        <div className="flex justify-center items-center min-h-screen">
          <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
            <h2 className="text-2xl text-center font-semibold mb-4">
              Add Organization
            </h2>

            <form onSubmit={handleInsertData}>
              {/* Client Name */}

              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="mb-3">
                  <label
                    htmlFor="clientName"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Client
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        value={selectedClient}
                        onChange={(e) => setSelectedClient(e.target.value)}
                        onClick={handleClientSelect}
                      >
                        <option value="">Select Client</option>
                        {clients.map((client, index) => (
                          <option key={index} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Organization Type */}
                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Organization Type
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedOrgVal}
                        onChange={(e) => setSelectedOrgVal(e.target.value)}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                      >
                        <option value="">Select Org Type</option>
                        <option value="BaseClient"> Base Client </option>
                        <option value="Client">Client</option>
                        <option value="Customer">Customer</option>
                        <option value="Branch">Branch</option>
                        <option value="Partner">Partner</option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/*  Select Parent Organization */}
                <div className="mb-3">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Parent Organization
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onClick={handleOrgClientWise}
                        onChange={(e) => setSelectedParentVal(e.target.value)}
                      >
                        <option value="">Select Parent Organization</option>
                        {organizationData.map((org, index) => (
                          <option key={index} value={org.id}>
                            {org.organizationname}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/*   Oranization Name */}
              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="mb-3">
                  <label
                    htmlFor="keyPersonEmail"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Oranization Name
                  </label>
                  <input
                    type="text"
                    id="keyPersonEmail"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="orgName"
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                    required
                  />
                </div>

                {/*  Oranization Code */}
                <div className="mb-3">
                  <label
                    htmlFor="keyPersonEmail"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Oranization Code
                  </label>
                  <input
                    type="text"
                    id="keyPersonEmail"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                    name="orgCode"
                    value={orgCode}
                    onChange={(e) => setOrgCode(e.target.value)}
                  />
                </div>

                {/* Submit and Close Buttons */}
                <div className="col-span-2 flex justify-between space-x-4">
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Submit
                  </button>
                  <button
                    onClick={closeModal}
                    className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                  >
                    X
                  </button>
                </div>
              </div>
            </form>

            {/* Close button */}
          </div>
        </div>
      </div>

      {/* Modal for editing client */}
      <div
        className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
          isEditModalOpen ? "block" : "hidden"
        }`}
      >
        <div className="flex justify-center items-center min-h-screen">
          <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
            <h2 className="text-2xl text-center font-semibold mb-4">
              Edit Organization
            </h2>

            <form onSubmit={handleInsertData}>
              {/* Client Name */}

              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="mb-3">
                  <label
                    htmlFor="clientName"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Client
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        value={selectedClient}
                        onChange={(e) => setSelectedClient(e.target.value)}
                        onClick={handleClientSelect}
                      >
                        <option value="">Select Client</option>
                        {clients.map((client, index) => (
                          <option key={index} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Organization Type */}
                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Organization Type
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedOrgVal}
                        onChange={(e) => setSelectedOrgVal(e.target.value)}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                      >
                        <option value="">Select Org Type</option>
                        <option value="1"> Base Client </option>
                        <option value="2">Client</option>
                        <option value="3">Customer</option>
                        <option value="4">Branch</option>
                        <option value="5">Partner</option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/*  Select Parent Organization */}
                <div className="mb-3">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Parent Organization
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onClick={handleOrgClientWise}
                        onChange={(e) => setSelectedParentVal(e.target.value)}
                      >
                        <option value="">Select Parent Organization</option>
                        {organizationData.map((org, index) => (
                          <option key={index} value={org.id}>
                            {org.organizationname}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/*   Oranization Name */}
              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="mb-3">
                  <label
                    htmlFor="keyPersonEmail"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Oranization Name
                  </label>
                  <input
                    type="text"
                    id="keyPersonEmail"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="orgName"
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                    required
                  />
                </div>

                {/*  Oranization Code */}
                <div className="mb-3">
                  <label
                    htmlFor="keyPersonEmail"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Oranization Code
                  </label>
                  <input
                    type="text"
                    id="keyPersonEmail"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                    name="orgCode"
                    value={orgCode}
                    onChange={(e) => setOrgCode(e.target.value)}
                  />
                </div>

                {/* Submit and Close Buttons */}
                <div className="col-span-2 flex justify-between space-x-4">
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Update
                  </button>
                  <button
                    onClick={handleCloseModal}
                    className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                  >
                    X
                  </button>
                </div>
              </div>
            </form>

            {/* Close button */}
          </div>
        </div>
      </div>
      <ToastContainer />
    </Box>
    </>
  );
};

export default GyanniOrg;
